import {ApiRequestType, onRequestFailure, onRequestSuccess} from "store/middlewares/apiMiddleware";

const SLICE = 'stream';

export interface StreamAPICreateDataType {
  key: number,
  url: string|null,
  description: string|null,
  monitor_id: number,
  status_id: number,
  server_id: number,
  sport: string,
  tournament: string,
  team1: string,
  team2: string,
  start_date: string,
  start_time: string,
  resolution_id: number,
}

export interface StreamAPIDeleteDataType {
  ids: number[],
}

export interface StreamAPIRestoreDataType {
  ids: number[],
}

export interface StreamAPIUpdateDataType {
  id: number,
  key: number,
  url: string|null,
  description: string|null,
  server_id: number,
  monitor_id: number,
  status_id: number,
  sport: string,
  tournament: string,
  team1: string,
  team2: string,
  start_date: string,
  start_time: string,
  resolution_id: number,
}

export interface StreamAPIUpdateStatusDataType {
  status_id: number,
  ids: number[],
}

export interface StreamAPIListDataType {
  archive?: 'yes'|'no',
  monitoring?: 'yes'|'no',
}

export interface StreamAPIItemDataType {
  id: number,
}

export interface StreamAPIFindByKeyDataType {
  key: number,
}

export interface StreamAPISearchDataType {
  name: string,
}

export interface StreamAPIExportDataType {
  // ... no args
}

export interface StreamAPITemplateDataType {
  // ... no args
}

export const StreamAPI = {

  create: function (data: StreamAPICreateDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'create',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  delete: function (data: StreamAPIDeleteDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream`,
      method: 'DELETE',
      data: data,
      slice: SLICE,
      action: 'delete',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  restore: function (data: StreamAPIRestoreDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/archive`,
      method: 'DELETE',
      data: data,
      slice: SLICE,
      action: 'restore',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  update: function (data: StreamAPIUpdateDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream`,
      method: 'PUT',
      data: data,
      slice: SLICE,
      action: 'update',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  updateStatuses: function (data: StreamAPIUpdateStatusDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/streams/update/statuses`,
      method: 'PUT',
      data: data,
      slice: SLICE,
      action: 'updateStatuses',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  list: function (data: StreamAPIListDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/streams`,
      method: 'GET',
      data: data,
      slice: SLICE,
      action: 'list',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    }
  },

  item: function (data: StreamAPIItemDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType  {
    return {
      type: 'API',
      url: `/stream`,
      method: 'GET',
      data: data,
      slice: SLICE,
      action: 'item',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  search: function (data: StreamAPISearchDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/streams`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'search',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  import: function (file: any, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/streams/import`,
      method: 'POST',
      data: file,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      slice: SLICE,
      action: 'import',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  export: function (data: StreamAPIExportDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/streams/export`,
      method: 'GET',
      data: data,
      slice: SLICE,
      action: 'export',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  template: function (data: StreamAPITemplateDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/streams/template`,
      method: 'GET',
      data: data,
      slice: SLICE,
      action: 'template',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  findByKey: function (data: StreamAPIFindByKeyDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType  {
    return {
      type: 'API',
      url: `/stream/findby/key`,
      method: 'GET',
      data: data,
      slice: SLICE,
      action: 'findByKey',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  }
};

